// extracted by mini-css-extract-plugin
module.exports = {"host":"Sidebar_host__0NC50","wrapper":"Sidebar_wrapper__CeR9u","wrapperFixed":"Sidebar_wrapperFixed__e3DXN"};